import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
interface IProps {
    onToggleMenu: () => void
    showMenu: boolean
    children: React.ReactNode
}

const SideNavContent = ({ children, showMenu, onToggleMenu }: IProps) => {
    return (
        <div id='sideNavContent' className={'flex-right'}>
            <button
                id='menu-toggle'
                className='btn btn-sm'
                title='Toggle Sidebar'
                onClick={onToggleMenu}>
                {showMenu ? <FontAwesomeIcon size='2x' icon={['fas', 'angle-left']} /> : <FontAwesomeIcon size='2x' icon={['fas', 'angle-right']} />}
            </button>
            {children}
        </div>
    )
}

export default SideNavContent